module.exports = __webpack_public_path__ + "static/media/fullcharge-chart.34823516.svg";